import { useAuth } from 'fennec-ui';
import React from 'react'

import StatusBlock from '../../components/StatusBlock'
import PageLayout from '../../components/PageLayout';

const filters = () => [
	{
		label: "Не прочитан",
		display: item => item.tipNovayaInfa,
		name: "tipNovayaInfa",
		type: "bool",
		sort: true,
		filter: true,
		sorted: "DESC"
	},
	{
		label: "Дата статуса",
		display: item => item.status.dataPoslednegoIzmeneniya,
		name: "status.dataPoslednegoIzmeneniya",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Текст статуса",
		display: item => item.tekstStatusa,
		name: "tekstStatusa",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Тип участия",
		display: item => item.status.tekst01TipUchastiyaVFederatsii,
		name: "status.tekst01TipUchastiyaVFederatsii",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Регион",
		display: item => item.status.tekst11RO,
		name: "status.tekst11RO",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Текущий статус",
		display: item => item.status.tekst04StatusPoPriemu,
		name: "status.tekst04StatusPoPriemu",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Инициатор",
		display: item => item.status.tekst02Initsiator,
		name: "status.tekst02Initsiator",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Орган принятия решения",
		display: item => item.status.tekst12OgranPrinyatiyaResheniya,
		name: "status.tekst12OgranPrinyatiyaResheniya",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Дата инициирования",
		display: item => item.status.tekst03DataInitsiirovaniya,
		name: "status.tekst03DataInitsiirovaniya",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Дата реального назначения",
		display: item => item.status.tekst05DataPriema,
		name: "status.tekst05DataPriema",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Дата начала работы",
		display: item => item.status.tekst15DataNachalaRaboti,
		name: "status.tekst15DataNachalaRaboti",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Инициатор исключения",
		display: item => item.status.tekst07InitsiatorPoisklyucheniyu,
		name: "status.tekst07InitsiatorPoisklyucheniyu",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Дата заявки на исключение",
		display: item => item.status.tekst06DataPodachiNaIsklyuchenie,
		name: "status.tekst06DataPodachiNaIsklyuchenie",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Статус по исключению",
		display: item => item.status.tekst08StatusPoIsklyucheniyu,
		name: "status.tekst08StatusPoIsklyucheniyu",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Дата исключения",
		display: item => item.status.tekst09DataIsklyucheniya,
		name: "status.tekst09DataIsklyucheniya",
		type: "date",
		sort: true,
		filter: true
	}
];

export default function CommonStatusInfrastructure(props) {
	const auth = useAuth();
	return (
		<PageLayout hideBreadcrumbs={true}>
			<StatusBlock {...props} filters={filters} uuid="8f3999b2a11c"/>
		</PageLayout>
	);
}
